export default "__VITE_ASSET__Cdi60svy__"